import { render } from "./SelectTheme.vue?vue&type=template&id=c0d3a032&scoped=true"
import script from "./SelectTheme.vue?vue&type=script&lang=js"
export * from "./SelectTheme.vue?vue&type=script&lang=js"

import "./SelectTheme.vue?vue&type=style&index=0&id=c0d3a032&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0d3a032"]])

export default __exports__